import ZkMenuItemGroup from '../menu/src/menu-item-group';

/* istanbul ignore next */
ZkMenuItemGroup.install = function(Vue) {
  Vue.component(ZkMenuItemGroup.name, ZkMenuItemGroup);
};

export default ZkMenuItemGroup;



// WEBPACK FOOTER //
// ./src/packages/menu-item-group/index.js